import React from 'react';
import { motion } from 'framer-motion';

// Different animation variants you can choose from

// 1. Fade only (subtle, minimal)
const fadeVariants = {
  initial: { opacity: 0 },
  animate: { 
    opacity: 1,
    transition: { duration: 0.3, ease: 'easeOut' }
  },
  exit: { 
    opacity: 0,
    transition: { duration: 0.2, ease: 'easeIn' }
  },
};

// 2. Slide from right (like forward navigation)
const slideRightVariants = {
  initial: { opacity: 0, x: 100 },
  animate: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.3, ease: 'easeOut' }
  },
  exit: { 
    opacity: 0, 
    x: -100,
    transition: { duration: 0.25, ease: 'easeIn' }
  },
};

// 3. Slide from bottom (like revealing content)
const slideUpVariants = {
  initial: { opacity: 0, y: 50 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.35, ease: 'easeOut' }
  },
  exit: { 
    opacity: 0, 
    y: -50,
    transition: { duration: 0.25, ease: 'easeIn' }
  },
};

// 4. Scale and fade (zoom effect)
const scaleVariants = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { 
    opacity: 1, 
    scale: 1,
    transition: { duration: 0.4, ease: 'easeOut' }
  },
  exit: { 
    opacity: 0, 
    scale: 0.95,
    transition: { duration: 0.3, ease: 'easeIn' }
  },
};

// 5. Crossfade with blur (elegant, smooth)
const blurVariants = {
  initial: { opacity: 0, filter: 'blur(10px)' },
  animate: { 
    opacity: 1, 
    filter: 'blur(0px)',
    transition: { duration: 0.4, ease: 'easeOut' }
  },
  exit: { 
    opacity: 0, 
    filter: 'blur(10px)',
    transition: { duration: 0.3, ease: 'easeIn' }
  },
};

// 6. None (instant, no animation)
const noneVariants = {
  initial: { opacity: 1 },
  animate: { opacity: 1 },
  exit: { opacity: 1 },
};

const variants = {
  fade: fadeVariants,
  slideRight: slideRightVariants,
  slideUp: slideUpVariants,
  scale: scaleVariants,
  blur: blurVariants,
  none: noneVariants,
};

function PageTransition({ children, variant = 'fade' }) {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants[variant]}
      style={{ width: '100%' }}
    >
      {children}
    </motion.div>
  );
}

export default PageTransition;
